import React from 'react';
import { useSelector } from 'react-redux';
import { RegularButton } from 'fronton-react';
import { CalculatorIcon } from '@fronton/icons-react';
import { useTranslation } from 'react-i18next';
import { getIsBoosterAvailable, isCalculatorAvailable } from 'features/product-info/ducks/selectors';
import { createGetExperiment, getIsPdpBoosterExperiment } from 'features/page-model';
import { HIDE_CALCULATOR_INTERNAL_ID } from 'common/constants';
import { DATA_TESTID_BOOSTER_BUTTON, DATA_TESTID_BOOSTER_CONTAINER } from './constants';
import { boosterButtonStyles } from './styles';

export const PdpBoosterButton: React.FC = () => {
  const { t } = useTranslation();

  const isCalcHidden = useSelector(createGetExperiment(HIDE_CALCULATOR_INTERNAL_ID));
  const isCalcAvailable = useSelector(isCalculatorAvailable) && !isCalcHidden;
  const isShowBooster = useSelector(getIsBoosterAvailable) ?? false;
  const isPdpBoosterExperimentAvailable = useSelector(getIsPdpBoosterExperiment);

  const handleRedirectOnBooster = () => {
    window.open('/kalkulyator-remonta/raschet-stoimosti-kuhni', '_blank', 'noopener,noreferrer');
  };

  const isBoosterAvailable = isShowBooster && isPdpBoosterExperimentAvailable;
  const isShowBoosterButton = !isCalcAvailable && isBoosterAvailable;

  if (isShowBoosterButton) {
    return (
      <div data-testid={DATA_TESTID_BOOSTER_CONTAINER}>
        <RegularButton
          data-testid={DATA_TESTID_BOOSTER_BUTTON}
          size="l"
          variant="secondary"
          iconLeft={<CalculatorIcon />}
          label={t('calculator.ui.booster')}
          className={boosterButtonStyles}
          onClick={handleRedirectOnBooster}
        >
          {t('calculator.ui.booster')}
        </RegularButton>
      </div>
    );
  }

  return null;
};
